export default {
  en: {
    community: "Community",
    orangeReport: "Orange Report",
    editOrangeReport: "Edit Orange Report",
    noSubmittedOrangeReports: "No Submitted Orange Reports",
    createOrangeReport: "Create Orange Report",
    newOrangeReport: "New Orange Report",
    viewOrangeReport: "View Orange Report",
    orangeReports: "Orange Reports",
    serviceRequest: "Service Request",
    serviceRequests: "Service Requests",
    newServiceRequest: "New Service Request",
    customerQuickFind: "Customer Quick Find",
    myCustomers: "My customers",
    requests: "Requests",
    backToDashboard: "Back to Dashboard",
    serviceDate: "Service Date",
    quarterlyPlan: "Quarterly plan",
    servicesRendered: "Services Rendered",
    visitNotes: "Visit Notes",
    images: "Images",
    followUpAndActionItems: "Follow Up and Action Items",
    addImages: "Add Images",
    upTo: "up to",
    cancel: "Cancel",
    saveReport: "Save Report",
    submitReport: "Submit Report",
    requestStatus: "Request Status",
    printSelected: "Print Selected",
    dateCreated: "Date Created",
    issue: "Issue",
    serviceType: "Service Type",
    propertyAddress: "Property Address",
    description: "Description",
    assignedTo: "Assigned To",
    updates: "Updates",
    actions: "Actions",
    allOpenRequests: "All Open Requests",
    closedRequests: "Closed Requests",
    saveChanges: "Save Changes",
    residentNotepad: "Resident Notepad",
    openedDate: "Opened Date",
    serviceRequestType: "Service Request Type",
    contactInformation: "Contact Information",
    contactName: "Contact Name",
    contactPhone: "Contact Phone",
    serviceRequestDescription: "Service Request Description",
    createNewRequest: "Create New Request",
    addDescriptiionIncludeAddressOrLocationDetails: "Add descriptiion (include address or location details)",
    chooseType: "Choose Type",
    updateRequest: "Update Request",
    print: "Print",
    request: "Request",
    requestType: "Request Type",
    dueDate: "Due Date",
    openedBy: "Opened By",
    location: "Location",
    hoaOrIndividual: "HOA Or Individual",
    neighborhoodName: "Neighborhood Name",
    homeAddress: "Home Address",
    contactEmail: "Contact Email",
    preferredContactMethod: "Preferred Contact Method",
    youAreAboutToSubmitThisOrangeReportToYourCustomer: "You are about to submit this Orange Report to your customer.",
    areYouSureYouWantToSubmit: "Are you sure you want to submit?",
    continueEditing: "Continue Editing",
    yesSubmitReport: "Yes, Submit Report",
    confirmation: "Confirmation",
    orangeReportHasBeenCreated: "Orange Report has been created",
    close: "Close",
    displayThisImageWithTheOrangeReportListing: "Display this image with the orange report listing",
    photoDescription: "Photo description",
    to_submit_the_Orange_Report_please_select_at_least_one_service_and_upload_an_image: "To submit the Orange Report, please select at least one service and upload an image.",
    max_file_size_is: "Max file size is",
    browse_file: "Browse file",
    or_drop_file: "or drop file"
  },
  es: {
    community: "Comunidad",
    orangeReport: "Informe Naranja",
    editOrangeReport: "Editar informe naranja",
    noSubmittedOrangeReports: "No se han enviado informes naranjas",
    createOrangeReport: "Crear informe naranja",
    newOrangeReport: "Nuevo Informe Naranja",
    viewOrangeReport: "Ver informe naranja",
    orangeReports: "Informes Naranjas",
    serviceRequest: "Solicitud de Servicio",
    serviceRequests: "Solicitudes de Servicio",
    newServiceRequest: "Nueva solicitud de servicio",
    customerQuickFind: "Búsqueda rápida del cliente",
    myCustomers: "Mis clientes",
    requests: "Solicitudes",
    backToDashboard: "Volver al Panel",
    serviceDate: "Fecha de Servicio",
    quarterlyPlan: "Plan trimestral",
    servicesRendered: "Servicios Prestados",
    visitNotes: "Notas de Visita",
    images: "Imágenes",
    followUpAndActionItems: "Elementos de seguimiento y acción",
    addImages: "Añadir imágenes",
    upTo: "hasta",
    cancel: "Cancelar",
    saveReport: "Guardar informe",
    submitReport: "Enviar informe",
    requestStatus: "Estado de la solicitud",
    printSelected: "Imprimir seleccionado",
    dateCreated: "Fecha de creación",
    issue: "Asunto",
    serviceType: "Tipo de servicio",
    propertyAddress: "Dirección de la propiedad",
    description: "Descripción",
    assignedTo: "Asignado a",
    updates: "Actualizaciones",
    actions: "Comportamiento",
    allOpenRequests: "Todas las solicitudes abiertas",
    closedRequests: "Solicitudes cerradas",
    saveChanges: "Guardar cambios",
    residentNotepad: "Bloc de notas residente",
    openedDate: "Fecha de apertura",
    serviceRequestType: "Tipo de solicitud de servicio",
    contactInformation: "Información del contacto",
    contactName: "Nombre de contacto",
    contactPhone: "Teléfono de contacto",
    serviceRequestDescription: "Descripción de la solicitud de servicio",
    createNewRequest: "Crear nueva solicitud",
    addDescriptiionIncludeAddressOrLocationDetails: "Agregar descripción (incluya dirección o detalles de ubicación)",
    chooseType: "Elija tipo",
    updateRequest: "Solicitud de actualización",
    print: "Imprimir",
    request: "Pedido",
    requestType: "Tipo de solicitud",
    dueDate: "Dos citas",
    openedBy: "Abierto por",
    location: "Ubicación",
    hoaOrIndividual: "HOA O individual",
    neighborhoodName: "Nombre del barrio",
    homeAddress: "Dirección de casa",
    contactEmail: "Correo electrónico de contacto",
    preferredContactMethod: "Método de contacto preferido",
    youAreAboutToSubmitThisOrangeReportToYourCustomer: "Estás a punto de enviar este Informe Naranja a su cliente.",
    areYouSureYouWantToSubmit: "¿Estás seguro de que desea enviarlo?",
    continueEditing: "No, regresar al informe",
    yesSubmitReport: "Sí, enviar",
    confirmation: "Confirmación",
    orangeReportHasBeenCreated: "El Informe Naranja ha sido creado",
    close: "Cerrar",
    displayThisImageWithTheOrangeReportListing: "Mostrar esta imagen junto con el listado del Informe Naranja",
    photoDescription: "Descripción de la foto",
    to_submit_the_Orange_Report_please_select_at_least_one_service_and_upload_an_image: "Para enviar el Informe Naranja, seleccione lo minimo de un servicio y suba lo minimo de una photo.",
    max_file_size_is: "El tamaño máximo de archivo es de ",
    browse_file: "Buscar foto",
    or_drop_file: "en archivos"
  },
  getTranslatedText(lang, key) {
    return this[lang][key];
  }
};
